import { MDBIcon } from "mdbreact";
import Button from "../../../components/Button/Button";
import handleCurrency from "../../../components/CurrencyFormat";
import "./InvoiceListModal.css";

export default function InvoiceListModal({ invoices, onClose }) {
  if (invoices === null) return null;

  return (
    <div className="invoice-list-modal-overlay" onClick={onClose}>
      <div
        className="invoice-list-modal-card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="invoice-list-modal-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          className="invoice-list-modal-close"
          aria-label="Tutup"
          onClick={onClose}
        >
          <MDBIcon icon="times" />
        </button>

        <div className="invoice-list-modal-icon">
          <MDBIcon icon="file-invoice" />
        </div>
        <h5 id="invoice-list-modal-title" className="invoice-list-modal-title">
          Bundle Invoice Details
        </h5>

        <div className="invoice-list-modal-content">
          {invoices.length ? (
            <table className="table table-bordered mb-0">
              <thead>
                <tr>
                  <th>Invoice Number</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map((invoice) => (
                  <tr key={invoice.invoiceNo}>
                    <td>{invoice.invoiceNo}</td>
                    <td>{`IDR ${handleCurrency(invoice.amount)}`}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className="invoice-list-modal-empty">
              No invoices in this bundle.
            </p>
          )}
        </div>

        <div className="invoice-list-modal-actions">
          <Button text="CLOSE" onClick={onClose} />
        </div>
      </div>
    </div>
  );
}
